export type NDICreditsBalance = {
  balance: string;
  currency: string;
};

/**
 * GET /api/v1/subscriptions/ndi-credits/balance/
 */
export const GET_NDI_CREDITS_BALANCE_PATH = 'subscriptions/ndi-credits/balance/';
export type GetNDICreditsBalanceRequestQueryParams = { org: string };
export type GetNDICreditsBalanceErrorDto = Error;

export type NDICreditsTransaction = {
  id: number;
  uuid: string;
  date: string;
  description: string;
  type: 'debit' | 'credit';
  amount: string;
  balance_after: string;
  job_subscription_display_name: string | null;
  subscription_account_name: string | null;
  subscription_account_balance: string | null;
};

/**
 * GET /api/v1/subscriptions/ndi-credits/transactions/
 */
export const GET_NDI_CREDITS_TRANSACTIONS_PATH = 'subscriptions/ndi-credits/transactions/';
export type GetNDICreditsTransactionsRequestQueryParams = {
  org: string;
  limit?: number;
  offset?: number;
};
export type GetNDICreditsTransactionsSuccessDto = {
  count: number;
  next: string | null;
  previous: string | null;
  results: NDICreditsTransaction[];
};
export type GetNDICreditsTransactionsErrorDto = Error;

/**
 * POST /api/v1/subscriptions/ndi-credits/add/
 */
export const POST_NDI_CREDITS_ADD_PATH = 'subscriptions/ndi-credits/add/';
export type PostNDICreditsAddRequestQueryParams = { org: string };
export type PostNDICreditsAddRequestBodyData = {
  amount: string;
  description: string;
};
export type PostNDICreditsAddErrorDto = Error;

/**
 * POST /api/v1/subscriptions/ndi-credits/manual-cost/
 */
export const POST_NDI_MANUAL_JOB_SUBSCRIPTION_COST_PATH = 'subscriptions/ndi-credits/manual-cost/';
export type PostNDIManualJobSubscriptionCostRequestBodyData = {
  job_subscription: string;
  amount: string;
  description: string;
};
export type PostNDIManualJobSubscriptionCostErrorDto = Error;
